import DiagSystemUtils from '../../../../../common/nodejs/diagSystemUtils';
import { REQUEST_STATUS_COMPLETED } from '../../../../../share/util/api/polling';
import apiService from '../../../../../share/util/api/service';
import { getAbbrSysName } from '../../../../../share/util/systemName';
import WS45Dialog from '../Requirement045Dialog';
import requirement045Utils from './Requirement045Utils';

/**
 * [obd] OBD通信規格判定 
 * @param {instance} self 呼び出し元this
 */
export async function judgeObdCommunicationStandard(self) {
  try {
    self.isLoading = true;
    const response = await requirement045Utils.doPolling(
      self,
      apiService.OBD,
      { project_id: self.projectId },
      `/netApps/${self.netAppId}/getVehicleObdInfo`,
      `/netApps/${self.netAppId}/requests/`,
    );
    if (response && response.data.status === REQUEST_STATUS_COMPLETED) {
      self.obdDataId = response.data.results.obd_data_id;
      // 正常終了 : [obd] システム名読出しへ遷移
      await readSystemName(self);
    } else {
      throw new Error('Unexpected error occurred');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.JUDGE_OBD_COMMUNICATION_STANDARD, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

/**
 * [obd] システム名読出し
 * @param {instance} self 呼び出し元this
 */
export async function readSystemName(self) {
  try {
    self.isLoading = true;
    const response = await requirement045Utils.doPolling(
      self,
      apiService.OBD,
      {},
      `/netApps/${self.netAppId}/obd/${self.obdDataId}/readSystemName`,
      `/netApps/${self.netAppId}/requests/`
    );
    if (response && response.data.status === REQUEST_STATUS_COMPLETED) {
      // 正常終了 : [wsp] judge 実行可否確認へ遷移
      const targetItem = response.data.results.obd_info.find(
        item => DiagSystemUtils.isEngineByAbbreviationId(getAbbrSysName(item.diagnostic_system_id))
      );
      if (targetItem && targetItem.system_no) {
        self.systemNo = targetItem.system_no;
        await self.initCommunication();
        return;
      } else {
        throw new Error('Unexpected error occurred: No system_no');
      }
    } else {
      throw new Error(`Invalid response: ${response}`);
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.READ_SYSTEM_NAME, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

/**
 * [obd] 初期化通信
 * @param {instance} self 呼び出し元this
 */
export async function initCommunication(self) {
  try {
    self.isLoading = true;
    const response = await requirement045Utils.doPolling(
      self,
      apiService.OBD,
      {},
      `/netApps/${self.netAppId}/obd/${self.obdDataId}/systems/${self.systemNo}/initialize`,
      `/netApps/${self.netAppId}/requests/`
    );
    if (response && response.data.status === REQUEST_STATUS_COMPLETED) {
      await self.getSupportMenu();
    } else {
      throw new Error('Unexpected error occurred');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.INIT_COMMUNICATION, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

/**
 * サポート読出し結果取得
 * @param {instance} self 呼び出し元this
 */
export async function getSupportMenu(self) {
  try {
    self.isLoading = true;
    const response = await requirement045Utils.doSyncRequest(
      self,
      apiService.OBD,
      `/netApps/${self.netAppId}/obd/${self.obdDataId}/systems/${self.systemNo}/menuConfig`
    );
    if (
      response &&
      response.data.is_show_data_monitor && // PIDのサポート読出しが正常終了
      response.data.is_show_onboard_system_test && // TestIDのサポート読出しが正常終了
      response.data.is_show_onboard_monitor_test // MIDのサポート読出しが正常終了
    ) {
      await self.getSupportIdsProcess();
    } else {
      throw new Error('Unexpected error occurred');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.GET_SUPPORT_MENU, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

/**
 * サポートID取得
 * @param {instance} self 呼び出し元this
 */
export async function getSupportIdsProcess(self) {
  const supportIds = await self.getSupportIds();
  if (supportIds.includes("01")) {
    await self.judgeReadinessCode();
  } else {
    // 異常終了 : エバポリークテスト失敗表示へ遷移
    self.isLoading = false;
    self.dialog.phase = WS45Dialog.PHASE.EVAPO_LEAK_TEST_FAILURE;
  }
}

/**
 * [obd] サポートID取得API実行
 * @returns {Array} サポートID一覧
 */
export async function getSupportIds(self) {
  try {
    self.isLoading = true;
    const response = await requirement045Utils.doSyncRequest(
      self,
      apiService.OBD,
      `/netApps/${self.netAppId}/obd/${self.obdDataId}/systems/${self.systemNo}/supportList/ost`,
    );
    return (response && response.data.support_ids !== null) ? response.data.support_ids : [];
  } finally { /* noop */ }
}

export default {
  judgeObdCommunicationStandard,
  readSystemName,
  initCommunication,
  getSupportMenu,
  getSupportIdsProcess,
  getSupportIds,
};
